import { useMsal } from "@azure/msal-react";
import { DataAccessContext } from "../../Contexts/DataAccessContext";
import { useContext, useMemo } from "react";
import {
  loginRedirect,
  tenantIdNameMap,
  TenantName,
} from "../../Api/Common/Auth";
import { AccountInfo } from "@azure/msal-browser";
import {
  CommandBar,
  DetailsList,
  Dropdown,
  ICommandBarItemProps,
  IDropdownOption,
  mergeStyleSets,
  Panel,
  PanelType,
  SelectionMode,
} from "@fluentui/react";
import { columns } from "./settingsPanelColumnDefinitions";

interface AccountItem {
  key: string;
  name: string;
  tenantName: TenantName;
  account: AccountInfo;
}

const SettingsPanel: React.FC<{ dismissPanel: () => void }> = ({
  dismissPanel,
}) => {
  const { accounts } = useMsal();
  const { activeAccount, setActiveAccount } = useContext(DataAccessContext);

  const { gridItems, dropdownOptions } = useMemo(() => {
    const gridItems = accounts.map((x) => {
      return {
        key: x.username,
        name: x.username,
        tenantName: tenantIdNameMap[x.tenantId] || x.tenantId,
        account: x,
      } as AccountItem;
    });
    const dropdownOptions = gridItems.map((x) => {
      const item: IDropdownOption = {
        key: x.account.username,
        text: `${x.tenantName} (${x.account.username})`,
        data: x.account,
      };
      return item;
    });
    return { gridItems, dropdownOptions };
  }, [accounts]);

  return (
    <Panel
      headerText="Manage Accounts"
      isOpen
      closeButtonAriaLabel="Close"
      type={PanelType.medium}
      isLightDismiss
      onDismiss={dismissPanel}
    >
      <Dropdown
        label="Primary account"
        options={dropdownOptions}
        selectedKey={activeAccount?.username}
        onChange={(_, option) => {
          if (option) {
            setActiveAccount(option.data);
          }
        }}
      />
      <h3 className={styles.header}>Signed-in accounts</h3>
      <DetailsList
        items={gridItems}
        columns={columns}
        selectionMode={SelectionMode.none}
      />
      <CommandBar items={commandItems} className={styles.commandBarStyles} />
    </Panel>
  );
};

const commandItems: ICommandBarItemProps[] = [
  {
    key: "addAccount",
    text: "Add account",
    iconProps: { iconName: "Add" },
    onClick: () => {
      loginRedirect();
    },
  },
];

const styles = mergeStyleSets({
  commandBarStyles: {
    padding: 0,
    marginBottom: -10,
  },
  header: {
    fontWeight: 600,
    marginTop: 20,
    marginBottom: 0,
  },
});

export default SettingsPanel;
